<div *ngIf="loader; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="divHome">
    <h1>Ver Programación Aventura</h1>

    <div style="display: flex; justify-content: center; margin: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <mat-label>Filtrar</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Filtrar Búsqueda"
        />
      </mat-form-field>
    </div>

    <div class="divButtons">
      <mat-form-field class="buttonFilterFecha">
        <mat-label>Fecha </mat-label>

        <mat-datepicker-toggle
          matSuffix
          [for]="rangePicker"
        ></mat-datepicker-toggle>

        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate placeholder="Inicio" [(ngModel)]="startDate" />
          <input matEndDate placeholder="Fin" [(ngModel)]="endDate" />
        </mat-date-range-input>

        <mat-date-range-picker #rangePicker>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>Cancel</button>
            <button
              style="background-color: rgb(184, 69, 18)"
              mat-raised-button
              color="primary"
              (click)="applyFilterSelect()"
              matDateRangePickerApply
            >
              Filtrar
            </button>

            <button
              mat-button
              matDateRangePickerCancel
              (click)="cleanDateSelected(1)"
            >
              Limpiar
            </button>
            <!-- <mat-icon style="color:rgb(96, 96, 96);font-size: 1rem; width: 100%;" (click)="cleanDateSelected()" >close</mat-icon> -->
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>

      <mat-form-field class="buttonFilterFecha">
        <mat-label>Fecha Actualización</mat-label>

        <mat-datepicker-toggle
          matSuffix
          [for]="rangePicker2"
        ></mat-datepicker-toggle>

        <mat-date-range-input [rangePicker]="rangePicker2">
          <input matStartDate placeholder="Inicio" [(ngModel)]="startDate2" />
          <input matEndDate placeholder="Fin" [(ngModel)]="endDate2" />
        </mat-date-range-input>

        <mat-date-range-picker #rangePicker2>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>Cancel</button>
            <button
              style="background-color: rgb(184, 69, 18)"
              mat-raised-button
              color="primary"
              (click)="applyFilterSelect()"
              matDateRangePickerApply
            >
              Filtrar
            </button>

            <button
              mat-button
              matDateRangePickerCancel
              (click)="cleanDateSelected(2)"
            >
              Limpiar
            </button>
            <!-- <mat-icon style="color:rgb(96, 96, 96);font-size: 1rem; width: 100%;" (click)="cleanDateSelected()" >close</mat-icon> -->
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>File</mat-label>
        <mat-select
          [(value)]="selectedFile"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let file of fileArray" value="{{ file }}">{{
            file
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Estado File</mat-label>
        <mat-select
          [(value)]="selectedEstadoFile"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let estadoFile of arrayEstadoFile"
            value="{{ estadoFile }}"
            >{{ estadoFile }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Categoría Producto</mat-label>
        <mat-select
          [(value)]="selectedCategoriaProducto"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let categoriaProducto of arrayCategoriaProducto"
            value="{{ categoriaProducto }}"
            >{{ categoriaProducto }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Sub Categoría Producto</mat-label>
        <mat-select
          [(value)]="selectedSubCategoriaProducto"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let subCategoriaProducto of arraySubCategoriaProducto"
            value="{{ subCategoriaProducto }}"
            >{{ subCategoriaProducto }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Tipo Servicio</mat-label>
        <mat-select
          [(value)]="selectedTipoServicio"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let tipo of arrayTipoServicio"
            value="{{ tipo }}"
            >{{ tipo }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Categoría Servicio</mat-label>
        <mat-select
          [(value)]="selectedSubCategoria"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let subcategoria of arraySubCategoria"
            value="{{ subcategoria }}"
            >{{ subcategoria }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Servicio</mat-label>
        <mat-select
          [(value)]="selectedService"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let el of arrayService" value="{{ el }}">{{
            el
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Proveedor</mat-label>
        <mat-select
          [(value)]="selectedProvider"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let el of arrayProvider" value="{{ el }}">{{
            el
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>OS</mat-label>
        <mat-select
          [(value)]="selectedOS"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let el of arrayOS" value="{{ el }}">{{
            el
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Estado OS</mat-label>
        <mat-select
          [(value)]="selectedEstadoOS"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let el of arrayEstadoOS" value="{{ el }}">{{
            el
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!--        <mat-form-field style="width: 15rem" appearance="fill" class="buttonFilter">-->
      <!--          <mat-label>Rango de fechas</mat-label>-->
      <!--          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">-->
      <!--            <input formControlName="start" matStartDate>-->
      <!--            <input formControlName="end" matEndDate>-->
      <!--          </mat-date-range-input>-->
      <!--&lt;!&ndash;          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>&ndash;&gt;-->
      <!--          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
      <!--          <mat-date-range-picker #picker></mat-date-range-picker>-->
      <!--        </mat-form-field>-->
    </div>
    <div class="secctionButtonOS">
      <div style="height: 50%">
        <button
          mat-raised-button
          [ngClass]="{
            buttonActive: estadoBtnMasivo > 0,
            buttonDisable: estadoBtnMasivo === 0
          }"
          (click)="sendReservaOS()"
        >
          Generar OS
        </button>
      </div>
      <div style="height: 50%; height: 40px !important">
        <p
          *ngIf="estadoBtnMasivo === 0 && messageButtonOS"
          style="color: red; font-size: 0.8rem"
        >
          <i>* Seleccione los servicos que desea reservar Orden de Servico</i>
        </p>
      </div>
    </div>

    <div class="example-container">
      <table
        *ngIf="!loader"
        mat-table
        matSort
        [dataSource]="dataSource"
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="Check">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? toggleAllRows(dataSource.data) : null"
              [checked]="isAllSelected(dataSource.data)"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox
              [checked]="element.checked"
              (change)="updateCheck(element)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="fileNumber">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            FILE
          </th>
          <td mat-cell *matCellDef="let row" class="secctionHeaderBody">
            {{ row.fileNumber }}{{ row.fileExtend }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tipoMoneda">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            TIPO MONEDA
          </th>
          <td mat-cell *matCellDef="let row" class="secctionHeaderBody">
            {{ row.tipoMoneda }}
          </td>
        </ng-container>

        <ng-container matColumnDef="estadoFile">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            ESTADO FILE
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.estadoFile ? element.estadoFile : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="categoriaProducto">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            CATEGORIA
          </th>
          <td mat-cell *matCellDef="let row" class="secctionHeaderBody">
            {{ row.objProducto?.categoriaProducto }}
          </td>
        </ng-container>
        <ng-container matColumnDef="subCategoriaProducto">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            SUB-CATEGORIA
          </th>
          <td mat-cell *matCellDef="let row" class="secctionHeaderBody">
            {{ row.objProducto?.subCategoriaProducto }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ruta">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            RUTA
          </th>
          <td mat-cell *matCellDef="let row" class="secctionHeaderBody">
            {{ row.objProducto?.nombre }}
          </td>
        </ng-container>

        <!--            <ng-container matColumnDef="date">-->
        <!--              <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> FECHA</th>-->
        <!--&lt;!&ndash;              <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.dateRange | date:'dd/MM/yyyy'}} </td>&ndash;&gt;-->
        <!--              <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.dateRange}} </td>-->
        <!--            </ng-container>-->

        <ng-container matColumnDef="categoriaServicio">
          <th mat-header-cell *matHeaderCellDef>TIPO SERVICIO</th>
          <td mat-cell *matCellDef="let element">{{ element.tipoServicio }}</td>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            NOMBRE SERVICIO
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.nombreServicio }}
          </td>
        </ng-container>

        <ng-container matColumnDef="numPAX">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            PAX
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element?.lstPaX?.length }}
          </td>
        </ng-container>

        <ng-container matColumnDef="proveedor">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            PROVEEDOR
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.objProvider.nombre }}
          </td>
        </ng-container>

        <ng-container matColumnDef="orderNumber">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            NUM OS
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.order?.displayCode || element.order?.orderNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="reservationStatus">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            ESTADO OS
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.order?.reservationStatus || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="reservationNumber">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            CÓDIGO RESERVA
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.order?.reservationNumber || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            FECHA CREACIÓN
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.objServicio?.createdAt | date: 'dd/MM/yyyy h:mm:ss' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updatedAt">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            FECHA ACTUALIZACIÓN
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            {{ element.objServicio?.updatedAt | date: 'dd/MM/yyyy h:mm:ss' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cambiarProvider">
          <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">
            CAMBIAR PROVEEDOR
          </th>
          <td mat-cell *matCellDef="let element" class="secctionBody">
            <mat-icon
              class="icon_color_black"
              (click)="
                openDialogProvider(
                  element.tipoServicio,
                  element.nombreServicio,
                  element.itineraryId,
                  element.id,
                  element.objProvider.nombre,
                  element.objServicio.categoriaServicio,
                  element.locacion
                )
              "
              >person</mat-icon
            >
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsServicios"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsServicios"
        ></tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </div>
</ng-template>
